var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBnb = function SvgBnb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m4.705 8 .005 1.934 1.644.967v1.132l-2.605-1.528v-3.07zm0-1.934v1.127l-.957-.566V5.5l.957-.566.962.566zM7.04 5.5l.957-.566.962.566-.962.566z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.396 9.533V8.401l.958.566v1.127zm1.644 1.774.957.566.962-.566v1.127L7.997 13l-.957-.566zM10.33 5.5l.957-.566.962.566v1.127l-.962.566V6.066zm.957 4.434L11.294 8l.957-.566v3.07l-2.605 1.529V10.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.604 9.533-.958.561V8.967l.958-.566z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m10.602 6.467.005 1.132-1.648.967v1.939l-.957.56-.957-.56V8.566l-1.648-.967V6.467l.961-.566 1.638.971 1.648-.971.962.566zM5.396 4.533 7.996 3l2.606 1.533-.957.566-1.648-.971-1.643.971z"
  })));
};
export default SvgBnb;